import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class GameGalacticWarriorAPI extends BaseAPI {}

export default new GameGalacticWarriorAPI('v1/game-galactic-warrior', 'ExerciseStore')
